import React from 'react';
import ActionIcon from './ActionIcon';
import ActionIcons from './ActionIcons';

type THeartIcon = {
  isFavorite?: boolean;
  onClick?: () => void;
  tabIndex?: string;
  className?: string;
  alwaysVisible?: boolean;
  ariaLabel?: string;
};

function getFavoriteData(isFavorite: boolean) {
  if (isFavorite) {
    return {
      icon: 'heart_filled',
      color: 'signal-error-default',
    };
  }
  return {
    icon: 'heart',
    color: '',
  };
}

const HeartIcon = ({
  isFavorite = false,
  onClick = () => {},
  tabIndex,
  className = '',
  alwaysVisible = false,
  ariaLabel,
}: THeartIcon) => {
  const { icon, color } = getFavoriteData(isFavorite);

  return (
    <ActionIcons alwaysVisible={alwaysVisible}>
      <ActionIcon
        icon={icon}
        onClick={onClick}
        tabIndex={tabIndex}
        className={className}
        ariaLabel={ariaLabel}
        color={color}
      />
    </ActionIcons>
  );
};

export default HeartIcon;
